<script setup lang="ts">
import { translate } from '~/composables/translate/translations'
import { useOfferStore } from '~/stores/offer'
import { useReferralStore } from '~/stores/referral'

const referralStore = useReferralStore()
const metaFlowOffersEnabled = useRuntimeConfig().public.META_OFFERS_ENABLED && referralStore.isMetaFlow

const pickUpImg = `${useRuntimeConfig().public.imageURL}/selling-args/pick-up.svg`
const fuelImg = `${useRuntimeConfig().public.imageURL}/selling-args/fuel.svg`
const keylessImg = `${useRuntimeConfig().public.imageURL}/selling-args/keyless.svg`

const offerStore = useOfferStore()

function offerDescriptionTranslation(): string {
  const description = offerStore.selectedOffer?.description?.replace('+ ', '') ?? '19 €' // TODO: <-- hardcoded 19 €
  return translate(
    'safety_proceed_overlay_prebooking_fuel_price_description',
    { '{fuel_price_description}': description },
  )
}
</script>

<template>
  <section class="flex flex-col gap-y-24">
    <h2 class="text-black-100 lg:text-2xl">
      {{ translate('safety_proceed_overlay_prebooking_title') }}
    </h2>

    <article class="text-black-100 bg-mint-10 p-16 rounded-xl space-y-8 max-lg:flex-row">
      <ul class="list-none">
        <li>
          <figure>
            <img :src="pickUpImg" alt="Locate the vehicle and just drive">
            <figcaption>
              <p class="font-bold">
                {{ translate('safety_proceed_overlay_prebooking_pickup_subtitle') }}
              </p>
              {{ translate('selling_proposition_prebooking_pick_up') }}
            </figcaption>
          </figure>
        </li>
        <li v-if="!metaFlowOffersEnabled">
          <figure>
            <img :src="fuelImg" class="max-md:hidden" alt="Fuel costs are on us">
            <figcaption>
              <p class="font-bold">
                {{ translate('safety_proceed_overlay_prebooking_fuel_price_subtitle') }}
              </p>
              {{ offerDescriptionTranslation() }}
            </figcaption>
          </figure>
        </li>
        <li>
          <figure>
            <img :src="keylessImg" class="max-md:hidden" alt="This car is keyless">
            <figcaption>
              <p class="font-bold">
                {{ translate('safety_proceed_overlay_prebooking_keyless_subtitle') }}
              </p>
              {{ translate('selling_proposition_prebooking_keyless') }}
            </figcaption>
          </figure>
        </li>
      </ul>
    </article>
  </section>
</template>

<style lang="scss" scoped>
figure {
  @apply w-fit flex flex-col md:flex-row items-center
}

img {
  @apply w-[120px] h-[120px]
}

figcaption {
  @apply text-xs my-[12px] md:text-left  md:ml-24
}

li {
  @apply flex flex-row
}
</style>
